import React, {Component} from 'react'
import moment from 'moment'
import 'moment/locale/de';
import './OrderCalendarPage.scss'
import leftArrow from '../imgs/order-calendar-left-arrow.svg'
import rightArrow from '../imgs/order-calendar-right-arrow.svg'
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Link} from 'react-router-dom';

import OrderOptions from './OrderOptions';
import {push } from 'connected-react-router'

import { arrayToObject } from '../helper'

moment.locale('de');

class OrderCalendarPage extends Component {
    constructor(props) {
        super(props)
        this.state = {dateFromTraining: false}
    }

    componentWillReceiveProps(props) {
        if (props.training && !this.state.dateFromTraining) {
            this.setState({dateFromTraining: true}, () => {
                this.props.setSelectedMonthDate(moment(props.training.date))
            })
        }
    }

    render() {
        const props = this.props;
        const now = moment(Date.now())
        const month = moment(props.selectedMonthDate).date(1);


        let noMoreTrainings = props.trainings.length == 0;
        if (!noMoreTrainings) {
            const lastTraining = props.trainings[props.trainings.length - 1];
            noMoreTrainings = moment(lastTraining.date).isBefore(month);
        }

        const end = moment(month)
            .add('1', 'month')
            .subtract(1, 'day');
        end.add(end.day()===0?0:7-end.day(), 'day')


        const range = []
        for (
                const start = moment(month).subtract((month.day()===0?7:month.day())-1, 'day');
                start.isSameOrBefore(end);
                start.add(1,'day')
            ) {
            const date = moment(start)
            const key = date.format('YYYY-MM-DD');

            const training = this.props.trainings.filter(t => t.date === key)[0]
            range.push({
                date: date,
                available: now.isBefore(date) && training && (training.freeSlots) >0,
                not_available: now.isBefore(date) && training && (training.freeSlots) == 0,
                slots: training && (training.slots - training.participants),
                freeSlots: training && (training.freeSlots),
                slots_total: training && training.slots,
                discount: training && training.offer,
                offer: training && training.id,
                selected: (training && this.props.training) && training.id === this.props.training.id,
            })
        }

        const type = this.props.trainingType

        const classNameForDay = (item) => {
            const classNames = ['order-calendar-day']
            if (item.selected)
                classNames.push("order-calendar-day--selected")
            if (!item.available)
                classNames.push("order-calendar-day--not-available")

            return classNames.join(' ')
        }

        let price = 0.00

        if (props.training && type) {
            price = this.props.selectedSlots * props.training.price
        }

        return (
            <div className="order-calendar">
                <div className="order-calendar-header">
                    <button className="order-calendar-header-arrow" onClick={() => this.props.prevMonth()}>
                        <img src={leftArrow} />
                    </button>
                    <a name="kalender" className="order-calendar-header-title">
                    {month.locale('de').format('MMMM YYYY')}
                    </a>

                    <button style={{visibility: noMoreTrainings?'hidden':'visible'}} className="order-calendar-header-arrow" onClick={() => this.props.nextMonth()}>
                        <img src={rightArrow} />
                    </button>
                </div>
                {noMoreTrainings && (
                <div className="order-calendar-days-empty">
                <h1>weitere Termine folgen</h1>
                </div>
                )}
                {!noMoreTrainings && (
                <div className="order-calendar-days">
                    <span className="order-calendar-dayname">Mo</span>
                    <span className="order-calendar-dayname">Di</span>
                    <span className="order-calendar-dayname">Mi</span>
                    <span className="order-calendar-dayname">Do</span>
                    <span className="order-calendar-dayname">Fr</span>
                    <span className="order-calendar-dayname">Sa</span>
                    <span className="order-calendar-dayname">So</span>
                    {range.map(item => {
                        const content = (
                            <div className={classNameForDay(item)}>
                                {item.available && item.slots && (
                                <span className="order-calendar-day-slots">
                                    {item.freeSlots}
                                    <span className="order-calendar-day-slots-tooltip">
                                    {item.freeSlots} Plätze von {item.slots_total} frei
                                    </span>
                                </span>
                                )}
                                <span className="order-calendar-day-number">{ item.date.format('DD') }</span>
                                {item.discount && (
                                <span className="order-calendar-day-discount">Angebot</span>
                                )}
                            </div>
                        )
                        

                        if (!item.available)
                            return <div
                                key={item.date.format()}
                                className={"order-calendar-day-container"}
                            >
                                {content}
                            </div>


                        return <Link
                            key={item.date.format()}
                            className={"order-calendar-day-container"}
                            to={
                                "/shop/"
                                + props.match.params.vehicleTypeId + "/"
                                + props.match.params.trainingTypeId + "/"
                                + item.offer
                            }
                            >
                            {content}
                        </Link>
                    })}
                </div>
                )}
                <aside className="order-calendar-sidebar shop-sidebar">
                    <OrderOptions {...this.props} />
                </aside>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
  const trainings = (state.shop.trainings || []).filter(t => t.trainingTypeId == props.match.params.trainingTypeId)
  trainings.sort((a,b) => a.date.localeCompare(b.date))

  return {
    participantCount: state.order.participants.length,
    trainingType: state.shop.trainingTypes[props.match.params.trainingTypeId],
    training: arrayToObject(trainings, 'id')[props.match.params.trainingId],
    trainings: trainings
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    nextMonth: () => dispatch({type: 'SHOP_NEXT_MONTH'}),
    selectOffer: (key) => dispatch({type: 'SHOP_SELECT_OFFER', offer: key}),
    prevMonth: () => dispatch({type: 'SHOP_PREV_MONTH'}),
    setSelectedMonthDate: (date) => dispatch({type: 'SHOP_SET_MONTH', date}),
    next: (trainingId, participantCount) => {
        dispatch({
            type: 'ORDER_CHANGE_TRAINING',
            trainingId: props.match.params.trainingId
        })
        dispatch(push('/bestellung/rechnungsinformationen'))
    },
    prev: () => props.history.goBack()
  }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderCalendarPage))



// WEBPACK FOOTER //
// ./src/pages/OrderCalendarPage.jsx